import { render, staticRenderFns } from "./borderRadiusPicker.vue?vue&type=template&id=ff71fd66&scoped=true"
import script from "./borderRadiusPicker.vue?vue&type=script&lang=js"
export * from "./borderRadiusPicker.vue?vue&type=script&lang=js"
import style0 from "./borderRadiusPicker.vue?vue&type=style&index=0&id=ff71fd66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff71fd66",
  null
  
)

export default component.exports